module.exports = __webpack_public_path__ + "img/16.af13536b.jpg";